import React from "react";
import { Link } from "react-router-dom";
import ProseLogo from "./ProseLogo";

/**
 * Site-wide footer used on both public and authenticated pages.
 * Includes the compliance disclosure, MisherTech attribution, and clearly
 * visible Terms of Use + Privacy Policy links (never hidden inside a menu).
 */
export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-16">
      <div
        className="max-w-[1400px] mx-auto px-6 py-10 text-xs text-slate-600 leading-relaxed"
        data-testid="site-footer"
      >
        <div className="mb-6" data-testid="footer-logo">
          <ProseLogo size={40} />
        </div>
        <div className="font-mono-tech text-[10px] text-slate-500 mb-3">Disclosure</div>
        ProSe.Claims is a technology platform operated by MISHERTECH. It is not a law firm
        and does not provide legal advice or representation. Information and documents
        produced through the platform may be incomplete or inaccurate and require independent
        review. Use of ProSe.Claims does not create an attorney-client relationship, and no
        outcome is promised or guaranteed.

        <nav
          className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-slate-700"
          aria-label="Legal"
          data-testid="footer-legal-nav"
        >
          <Link
            to="/terms"
            className="underline underline-offset-4 hover:text-slate-900"
            data-testid="footer-terms-link"
          >
            Terms of Use
          </Link>
          <Link
            to="/privacy"
            className="underline underline-offset-4 hover:text-slate-900"
            data-testid="footer-privacy-link"
          >
            Privacy Policy
          </Link>
          <Link
            to="/rd-case-study"
            className="underline underline-offset-4 hover:text-slate-900"
            data-testid="footer-case-study-link"
          >
            R&amp;D Case Study
          </Link>
          <Link
            to="/contact"
            className="underline underline-offset-4 hover:text-slate-900"
            data-testid="footer-contact-page-link"
          >
            Contact
          </Link>
          <a
            href="mailto:corporate@mishertech.com"
            className="underline underline-offset-4 hover:text-slate-900"
            data-testid="footer-contact-link"
          >
            Email
          </a>
        </nav>

        <div className="mt-6 flex items-center justify-between flex-wrap gap-3">
          <span>&copy; {year} Prose.claims.</span>
          <span className="font-mono-tech" data-testid="powered-by">
            Powered by <span className="text-slate-900 font-semibold">MisherTech</span> · Technology and infrastructure provider
          </span>
        </div>
      </div>
    </footer>
  );
}
